import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthRoutingModule } from './auth-routing.module';
import { AuthLoginComponent } from './auth-login/auth-login.component';
import {GoogleSigninButtonModule} from "@abacritt/angularx-social-login";
import {SharedModule} from "../shared/shared.module";

@NgModule({
  declarations: [
    AuthLoginComponent,
  ],
  imports: [
      CommonModule,
      AuthRoutingModule,
      GoogleSigninButtonModule,
      SharedModule,
  ],
  exports: [
    AuthLoginComponent,
  ]
})
export class AuthModule {}
